import React, {Component} from 'react'
import propTypes from 'prop-types'
import PartImageContainer from 'containers/partImage'
import {get} from 'lodash'
import Hintable from 'components/hintable'
import {OrderItemType} from 'helpers/orders'

class PartImageColumn extends Component {
  getNewPartEntity = (entity) => {
    return {
      id: -1,
      type: entity.partType,
    }
  }

  getPartFromEntity = (entity) => {
    const isNewRow = get(entity, 'isNewRow', false)
    const entityType = get(entity, 'type.id', null)

    if (isNewRow)
      return null

    if (entityType !== null && entityType === OrderItemType.entered)
      return this.getNewPartEntity(entity, entityType)

    const entityPart = get(entity, 'part', null)
    return entityPart === null
        ? entity
        : entityPart
  }

  getHoverPartImage = (part) => {
    return <PartImageContainer part={part} size={240}/>
  }

  render() {
    const {entity, style, className, getClass} = this.props
    const part = this.getPartFromEntity(entity)
    return part === null
        ? null
        : (
            <Hintable
                label={this.getHoverPartImage(part)}
                light={true}>
              <div
                  style={style}
                  className={`${className} ${getClass('iconColumn')}`}>
                <PartImageContainer part={part}/>
              </div>
            </Hintable>
        )
  }
}

PartImageColumn.propTypes = {
  entity: propTypes.object,
  style: propTypes.object,
  className: propTypes.string,
  getClass: propTypes.func,
}

export default PartImageColumn
